 import * as EventActionCreator from "./EventActionCreator";
 
 export function defaultEventsListState() {
    return {
      loading: false,
      response: null,
      error: null,
      page: 0,
      size: 10
    };
  }

  export const EventListReducer = (state, action) => {
      if( !state || action.type === EventActionCreator.EVENT_ACTION.RESET_EVENTS_LIST_STATE) {
        return {...state, ...defaultEventsListState()};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.REQUEST_EVENTS_LIST) {
        return {...state, loading: true , page: action.data.page, size: action.data.size };
      }

      if(action.type === EventActionCreator.EVENT_ACTION.RESPONSE_EVENTS_LIST) {
        return {...state, response: action.data, loading: false};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.ERROR_EVENTS_LIST){
        return {...state, error: action.data , loading:false, response: null, page:0, size: 10};
      }
        return state;
  }

  export function defaultWorkAnniversaryState() {
    return {
      loading: false,
      response: null,
      error: null,
     };
  }

  export const WorkAnniversaryWishesReducer = (state, action) => {
      if( !state || action.type === EventActionCreator.EVENT_ACTION.RESET_WORKANNIVERSARY_WISHES_STATE) {
        return {...state, ...defaultWorkAnniversaryState()};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.REQUEST_WORK_ANNIVERSARY_WISHES) {
        return {...state, loading: true };
      }

      if(action.type === EventActionCreator.EVENT_ACTION.RESPONSE_WORK_ANNIVERSARY_WISHES) {
        return {...state, response: action.data, loading: false};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.ERROR_WORK_ANNIVERSARY_WISHES){
        return {...state, error: action.data , loading:false, response: null};
      }
        return state;
  }

  export function defaultBirthdayState() {
    return {
      loading: false,
      response: null,
      error: null,
     };
  }

  export const BirthdayWishesReducer = (state, action) => {
      if( !state || action.type === EventActionCreator.EVENT_ACTION.RESET_BIRTHDAY_WISHES_STATE) {
        return {...state, ...defaultBirthdayState()};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.REQUEST_BIRTHDAY_WISHES) {
        return {...state, loading: true };
      }

      if(action.type === EventActionCreator.EVENT_ACTION.RESPONSE_BIRTHDAY_WISHES) {
        return {...state, response: action.data, loading: false};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.ERROR_BIRTHDAY_WISHES){
        return {...state, error: action.data , loading:false, response: null};
      }
        return state;
  }

  export function defaultEventsNotificationsListState() {
    return {
      loading: false,
      response: null,
      error: null,
      };
  }

  export const EventsNotificationsListReducer = (state, action) => {
      if( !state || action.type === EventActionCreator.EVENT_ACTION.RESET_EVENTS_NOTIFICATIONS_LIST_STATE) {
        return {...state, ...defaultEventsNotificationsListState()};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.REQUEST_EVENTS_NOTIFICATIONS_LIST) {
        return {...state, loading: true };
      }

      if(action.type === EventActionCreator.EVENT_ACTION.RESPONSE_EVENTS_NOTIFICATIONS_LIST) {
        return {...state, response: action.data, loading: false};
      }

      if(action.type === EventActionCreator.EVENT_ACTION.ERROR_EVENTS_NOTIFICATIONS_LIST){
        return {...state, error: action.data , loading:false, response: null};
      }
        return state;
  }